import styles from './style.module.scss';

function Spinner() {
    return (
        <div className={styles.hollow_dots_spinner}>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
        </div>
    );
};

export default Spinner;
